import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initConsentRuntime } from "./lib/consentRuntime";

// GA4 (Advanced Consent Mode), PostHog, RB2B and Leadfeeder are started here
// according to the production-host gate AND the visitor's consent choices.
initConsentRuntime();

createRoot(document.getElementById("root")!).render(<App />);
